import React from "react";
import { CONFIG } from "../const/config";

const Logo = () => {
  return (
    <a href="index.html" className="brand">
      <img
        className="logo logo-dark"
        alt="logo"
        src="img/logos/anthony-v-lombardo-dark.png"
      />
      <img
        className="logo logo-light"
        alt="logo"
        src="img/logos/anthony-v-lombardo-light.png"
      />
      <span className="signature">{CONFIG.siteName}</span>
    </a>
  );
};

export default Logo;
